import SatSyncCard from './SatSyncCard';
export default SatSyncCard;
